import { createContext } from 'react';
import { StateMethods } from '@hookstate/core';

export const searchValueContext = createContext<StateMethods<string> | undefined>(undefined);
